import React from 'react';
import PropTypes from 'prop-types';

import loadScript from 'core/utils/load-script';
import themePropTypes from 'core/utils/prop-types/theme';

import openAuth from '../Auth/utils';
import withTheme from 'core/hocs/withTheme';

/**
 * @author Evgeny Shiryaev <e.shiryaev@rambler-co.ru>
 */
class Comments extends React.PureComponent {
  static propTypes = {
    /** @ignore */
    className: PropTypes.string,
    /**
     * Ленивая инициализация виджета, он начнет загружаться только при подскролле к нему
     */
    lazy: PropTypes.bool,
    /**
     * Оффсет в пикселях для ленивой инициализации, при пересечении которого, мы начнем загружать виджет
     */
    lazyOffset: PropTypes.number,
    /**
     * Кол-во комментариев первого уровне, подгружаемых по кнопке "Показать еще" или при автоподгрузке
     */
    limit: PropTypes.number,
    /**
     * Максимальный уровень вложенности комментариев
     */
    maxLevel: PropTypes.number,
    /**
     * Показывать кнопку "Показать еще" вместо автоподгрузки
     */
    showMoreButton: PropTypes.bool,

    /**
     * Инлайн стили к обертке компонента
     */
    style: PropTypes.object,
    /**
     * Комментарии к статье отключены
     */
    isCommentsDisabled: PropTypes.bool,
    /** @ignore */
    theme: themePropTypes(`
      {
        controls: {
          comments: {
            const: {
              font,
            },
          },
        },
      }
    `),
    /**
     * ID топика
     */
    xid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  };

  static contextTypes = {
    host: PropTypes.string,
    ramblerCommentsAppId: PropTypes.number.isRequired,
    ramblerId: PropTypes.shape({
      rname: PropTypes.string,
      theme: PropTypes.string,
    }),
  };

  static defaultProps = {
    limit: 30,
    showMoreButton: true,
    lazyOffset: 300,
    maxLevel: 2,
    style: {},
  };

  state = { isOpen: false };

  componentDidMount() {
    if (process.env.NODE_ENV === 'test') return;

    if (!this.props.isCommentsDisabled) {
      const script = loadScript('//comments.rambler.ru/widget/v3/sdk.js', 'RamblerComments');
      const { ramblerCommentsAppId, ramblerId } = this.context;
      const ramblerIdTheme = ramblerId.theme || ramblerId.rname;

      const {
        theme,
        ...otherProps
      } = this.props;

      const options = {
        appId: ramblerCommentsAppId,
        theme: ramblerIdTheme,
        customLogin: true,
        ...theme.controls.comments.const,
      };

      script.then(comments => {
        comments
          .buildWidget('Comments', this.DOMNode, { ...options, ...otherProps })
          .then(widgetApi => (this.comments = widgetApi));

        comments.on('startLogin', () => openAuth(this.context));
      });
    }
  }

  componentWillUnmount() {
    if (this.comments) {
      this.comments.destroy();
    }
  }

  handleClose = () => {
    this.setState({ isOpen: false });
  };

  render() {
    const {
      className,
      style,
      isCommentsDisabled,
    } = this.props;

    if (isCommentsDisabled) {
      return <p>Комментарии к статье отключены</p>;
    }

    return (
      <div
        ref={node => (this.DOMNode = node)}
        className={className}
        style={style}
      />
    );
  }
}


const CommentsComponent = withTheme(Comments);
CommentsComponent.displayName = 'Comments';

export { Comments as StorybookComponent };
export default CommentsComponent;
